import Hero from "../components/Hero";
import Features from "../components/Features";
import WhyChooseUs from "../components/WhyChooseUs";
import Footer from "../components/Footer";
const Index = () => (
  <div className="flex flex-col min-h-screen">
    <Hero />
    <Features />
    <WhyChooseUs />
    <Footer />
  </div>
);

export default Index;